import createReactContext from '@ant-design/create-react-context';
export var TreeContext = createReactContext(null);


//////////////////
// WEBPACK FOOTER
// ../~/_rc-tree@2.1.2@rc-tree/es/contextTypes.js
// module id = 640
// module chunks = 0